angular.module('impactx.invoice').directive('ixInvoiceItemComplaintList', function ()
{
    return {
        scope: {
            item: "=",
            itemComplaintList: "=",
            deleteConditionFunc: "&",
            deleteItem: "&",
            trns: "=",
            data: "="
        },
        restrict: 'E',
        templateUrl: 'modules/invoice/templates/invoice-item-complaint-list.html',
        controller: function ($scope) {
            this.deleteConditionFunc = function () {
                if ($scope.deleteConditionFunc) {
                    return $scope.deleteConditionFunc();
                }
                return true;
            }

            this.deleteItem = function (event, iciId) {
                if ($scope.deleteItem) {
                    $scope.deleteItem({event: event, iciId: iciId});
                }
            }
        },
        controllerAs: '$ctrl'
    };
});